import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex: 1;
	gap: var(--spacing-small);
	align-items: baseline;
	min-width: var(--px-600);
	.motif-button {
		margin-left: auto;
	}
`;
